// Todo: Add office.com origin parameter to all of urls called from formsService
export var DESIGNER_MOBILE_URL = '/Pages/MobileDesignPage.aspx';
export var DESIGNER_URL = '/Pages/DesignPage.aspx';
export var NEO_DESIGN_URL = '/Pages/DesignPageV2.aspx';
//# sourceMappingURL=constants.js.map